import * as React from "react";
import AdminApprovalResidencyView from "./components/AdminApprovalResidency";

export default function AdminResidencyApprovalViewPage() {
    return (
    <>
      <AdminApprovalResidencyView />
    </>
  );
}